import { render, staticRenderFns } from "./FreeCancellationLabel.vue?vue&type=template&id=336ae710&scoped=true&"
import script from "./FreeCancellationLabel.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FreeCancellationLabel.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./FreeCancellationLabel.vue?vue&type=style&index=0&id=336ae710&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336ae710",
  null
  
)

export default component.exports